import { beginTask, endTask } from 'redux-nprogress';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectFormulasState } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'top200QB';
export const selectTop200QBState = state => state[STORE_KEY];
export const selectTop200QB = state => selectTop200QBState(state).currentTop200QB;

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  currentTop200QB: {},
  year: null,
  week: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default reducer;

// ------------------------------------
// Load Cheat Sheet from api
// ------------------------------------
export const LOAD_TOP200QB_REQUEST = `${STORE_KEY}/LOAD_TOP200QB_REQUEST`;
export const LOAD_TOP200QB_SUCCESS = `${STORE_KEY}/LOAD_TOP200QB_SUCCESS`;
export const LOAD_TOP200QB_ERROR = `${STORE_KEY}/LOAD_TOP200QB_ERROR`;

export const loadTop200QBRequest = payload => ({
  type: LOAD_TOP200QB_REQUEST,
  payload: { ...payload },
});
export const loadTop200QBSuccess = ({ cheatsheet }, year, week, formulaId) => ({
  type: LOAD_TOP200QB_SUCCESS,
  payload: { cheatsheet, year, week, formulaId },
});
export const loadTop200QBError = error => ({
  type: LOAD_TOP200QB_ERROR,
  payload: { error },
});

actions[LOAD_TOP200QB_REQUEST] = (state, { payload }) => ({ ...state,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_TOP200QB_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  currentTop200QB: payload.cheatsheet,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_TOP200QB_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadTop200QB = (year, week, formulaId) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadTop200QBRequest(year, week, formulaId));
    const top200QB = await api.cheatSheets.getByWeekTop200QB(year);

    return dispatch(loadTop200QBSuccess(top200QB, year, week, formulaId));
  } catch (error) {
    console.error(error);
    return dispatch(loadTop200QBError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View
// ------------------------------------
export const TOP200QB_VIEW = `${STORE_KEY}/TOP200QB_VIEW`;

viewNames[TOP200QB_VIEW] = 'Top200QB';
routes[TOP200QB_VIEW] = {
  path: '/fantasy-football-rankings-cheat-sheets/:year/top-200-qb-heavy',
  thunk: async (dispatch, getState) => {
    const state = getState();

    let { week, formulaId } = selectQuery(state);
    let { year } = state.location.payload;

    const { season: currentYear, week: currentWeek } = selectCurrent(state, 'projections');

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;

    await dispatch(loadWeeks(year));

    if (typeof week !== 'number') {
      if (year === currentYear) {
        week = currentWeek;
      } else {
        week = selectWeeks(getState(), year, 'projections')[0];
      }
    }

    // Needs to await otherwise data won't load on SSR
    await dispatch(loadTop200QB(year, week, formulaId));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/Top200QB/module/top200QB.js